module.exports = __webpack_public_path__ + "img/teamImg.3bdbb50b.png";